var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border m-4 p-16 rounded text-xl"},[_vm._v(" "+_vm._s(_vm.$t('login.logout.in.progress'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }